import api from '../api';

export const TICKETS_REQUEST = 'TICKETS_REQUEST';
export const TICKETS_SUCCESS = 'TICKETS_SUCCESS';
export const TICKETS_FAILURE = 'TICKETS_FAILURE';

const ticketsRequest = () => ({
  type: TICKETS_REQUEST,
});

const ticketsSuccess = payload => ({
  type: TICKETS_SUCCESS,
  payload,
});

const ticketsFailure = payload => ({
  type: TICKETS_FAILURE,
  payload,
});

export const ticketsFetch = () => async (dispatch, getState) => {
  const { expired } = getState().assistance.tickets;
  if (expired > Date.now()) return;
  dispatch(ticketsRequest());
  try {
    const res = await api('cabinet/assistance/tickets', 'get');
    dispatch(ticketsSuccess(res.data));
  } catch (error) {
    dispatch(ticketsFailure({ err: 'Запрос обращений не удался' }));
  }
};
